import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useEffect, useState} from 'react';

import {mainState} from '../../AppMainState';
import {Button} from '../../components/Button';
import {Card} from '../../components/Card';
import {FormInput} from '../../components/form/FormInput';
import {UserSettingsViewState} from './UserSettingsViewState';
import {DATE_TIME_FORMAT_COOKIE, setCurrentDateTimeFormat} from '../../helpers/helpers';
import Cookies from 'js-cookie';
import {demoEmail} from '../login/LoginState';
import {showWarning} from '../../helpers/alerts';


export const UserSettingsView: FC = observer(() => {
    const isDemo = mainState.currentUser?.email === demoEmail;
    useEffect(() => {
        if (isDemo) {
            showWarning('Demo mode', 'This screen is unavailable in demo mode');
        }
    }, []);

    const [state] = useState(() => new UserSettingsViewState());

    if (isDemo) {
        return <>Demo mode</>;
    }

    return <section className="">
        <h1 className="font-bold font-roboto-bold mb-4 text-3xl">
            User settings
        </h1>
        <Card
            className="mb-4"
            title="Change password">
            <div
                className={
                    'grid grid-cols-1 lg:grid-cols-2 gap-12'
                }
            >
                <div className="col-span-1">
                    <FormInput id="newpassword"
                               label="New password"
                               name="newpassword"
                               type="password"
                               onChange={(v) => state?.setNewPassword(v)}
                               value={state.newpassword} />
                    <FormInput id="confirmnewpassword"
                               label="Confirm new password"
                               name="confirmnewpassword"
                               type="password"
                               onChange={(v) => state?.setConfirmNewPassword(v)}

                               value={state.confirmnewpassword} />

                    <Button className="btn-primary" onClick={() => state?.changePassword()}>Change password for
                        user {mainState.currentUser?.email}</Button>

                </div>
            </div>
        </Card>
        <Card
            className="mb-4"
            title="Other">
            <div
                className={
                    'grid grid-cols-1 lg:grid-cols-2 gap-12'
                }
            >
                <div className="col-span-1">
                    <div className="form-check">
                        <div className="form-check-input-wrapper">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                defaultChecked={!!Cookies.get(DATE_TIME_FORMAT_COOKIE)}
                                onChange={() => {
                                    if (Cookies.get(DATE_TIME_FORMAT_COOKIE)) {
                                        Cookies.remove(DATE_TIME_FORMAT_COOKIE);
                                        setCurrentDateTimeFormat(undefined);
                                    } else {
                                        Cookies.set(DATE_TIME_FORMAT_COOKIE, 'YYYY-MM-DD HH:mm:ss');
                                    }
                                    setCurrentDateTimeFormat('YYYY-MM-DD- HH:mm:ss');
                                }}
                            />
                            <svg className={'form-check-tick'} viewBox="0 0 20 20">
                                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                            </svg>
                        </div>
                        <div>
                            <label
                                className="form-check-label">
                                Use one legitimate date format (YYYY-MM-DD- HH:mm:ss) regardless browser settings
                            </label>
                        </div>
                    </div>

                </div>
            </div>
        </Card>
        <Card
            className="mb-4 text-m-brand-red"
            title="Account deletion">
            <div
                className={
                    'grid grid-cols-1 lg:grid-cols-2 gap-12'
                }
            >
                <div className="col-span-1">
                    <Button className="bg-m-green" onClick={() => state?.deleteAccount()}>Delete account</Button>

                </div>
            </div>
        </Card>
        <Button className="btn btn-primary xs:block lg:hidden">Sign out {mainState.currentUser?.email}</Button>
    </section>;
});
